var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reservation-list"
  }, [_c('main', {
    staticClass: "main-content"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("預約資訊")]), _vm.reservations.length > 0 && !_vm.isLoadingReservations ? _c('div', {
    staticClass: "appointment-list"
  }, _vm._l(_vm.reservations, function (reservation, index) {
    return _c('ReservationCard', {
      key: reservation.reservationId,
      attrs: {
        "reservation": reservation,
        "isExpanded": _vm.expandedCards[index],
        "isSelected": _vm.selectedReservation && _vm.selectedReservation.reservationId === reservation.reservationId
      },
      on: {
        "click": function click($event) {
          return _vm.toggleCard(reservation, index);
        }
      }
    });
  }), 1) : _vm._e(), _vm.reservations.length === 0 && !_vm.isLoading ? _c('div', {
    staticClass: "empty-state"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 6v6l4 2"
    }
  })])]), _c('p', {
    staticClass: "empty-text"
  }, [_vm._v("您目前沒有預約紀錄")])]) : _vm._e(), _vm.hasMore && !_vm.isLoadingReservations ? _c('button', {
    staticClass: "btn btn-secondary btn-block",
    attrs: {
      "disabled": _vm.isLoadingMore
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoadingMore ? '載入中...' : '載入更多') + " ")]) : _vm._e()]), _c('div', {
    staticStyle: {
      "padding-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.selectedReservation
    },
    on: {
      "click": _vm.showCancelModal
    }
  }, [_vm._v("取消預約")])])]), _c('div', {
    staticClass: "tongxin-modal",
    class: {
      show: _vm.showCancelConfirmModal
    }
  }, [_c('div', {
    staticClass: "tongxin-modal__content"
  }, [_c('div', {
    staticClass: "tongxin-modal__header"
  }, [_c('div', {
    staticClass: "tongxin-modal__icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })])]), _c('h2', {
    staticClass: "tongxin-modal__title"
  }, [_vm._v("確認取消預約")])]), _c('div', {
    staticClass: "tongxin-modal__body"
  }, [_vm._m(0), _vm.selectedReservation ? _c('div', {
    staticClass: "cancel-info-box"
  }, _vm._l(_vm.getProcessedInfoBlock(_vm.selectedReservation.summary.infoBlock), function (item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "cancel-info-item"
    }, [_c('span', {
      staticClass: "cancel-info-label"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "cancel-info-value",
      class: {
        'text-red': item.title === '就診人' || item.title === '就診時段'
      }
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "tongxin-modal__buttons"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("返回")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.confirmCancel
    }
  }, [_vm._v("確認取消")])])])]), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "tongxin-modal__text"
  }, [_vm._v(" 確定要取消以下預約嗎？"), _c('br'), _vm._v(" 取消後將無法復原，需重新預約。 ")]);
}]

export { render, staticRenderFns }